import { render, staticRenderFns } from "./semiScreen.vue?vue&type=template&id=2dba427e&scoped=true"
import script from "./semiScreen.vue?vue&type=script&lang=js"
export * from "./semiScreen.vue?vue&type=script&lang=js"
import style0 from "./semiScreen.vue?vue&type=style&index=0&id=2dba427e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba427e",
  null
  
)

export default component.exports